import { render, staticRenderFns } from "./buildinginqlist.vue?vue&type=template&id=3c9c5746&scoped=true&"
import script from "./buildinginqlist.vue?vue&type=script&lang=js&"
export * from "./buildinginqlist.vue?vue&type=script&lang=js&"
import style0 from "./buildinginqlist.vue?vue&type=style&index=0&id=3c9c5746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c5746",
  null
  
)

export default component.exports